var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvertedcomma({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 134,
    viewBox: "0 0 146 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.707 5.24998L141.957 31.25C134.29 30.5833 128.207 31.9167 123.707 35.25C119.207 38.4167 116.124 43 114.457 49C112.957 54.8333 112.707 61.5 113.707 69H145.707V133.25H83.957V66.5C83.957 44.6666 89.1237 28.1666 99.457 17C109.79 5.66665 125.207 1.74998 145.707 5.24998ZM61.957 5.24998L58.207 31.25C50.5404 30.5833 44.457 31.9167 39.957 35.25C35.457 38.4167 32.3737 43 30.707 49C29.207 54.8333 28.957 61.5 29.957 69H61.957V133.25H0.207034V66.5C0.207034 44.6666 5.3737 28.1666 15.707 17C26.0404 5.66665 41.457 1.74998 61.957 5.24998Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedcomma);
export default __webpack_public_path__ + "static/media/invertedcomma.0bfd9248fca145c2a64195d5aed0c9cd.svg";
export { ForwardRef as ReactComponent };